import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import map from 'lodash/fp/map';
import filter from 'lodash/fp/filter';
import moment from 'moment';

import config from '../../config';
import { arrayRotateRight, getStartOfDay } from './helpers';

export const getWholeDaysOff = daysOff => flow(
  filter('wholeDay'),
  map('day'),
)(daysOff);

export const getScheduleWeekdaysFromSchedule = schedules => flow(
  get('0.workdays'),
  map('enabled'),
  arrayRotateRight
)(schedules);

export const getScheduleWeekdaysOffFromSchedule = schedules => flow(
  get('0.workdays'),
  filter({ enabled: false }),
  map('weekDay'),
  // days_off from the api are 1 based (1-7),
  // and JS dates are 0 based (0-6)
  map(day => day % 7)
)(schedules);

export const isWeekdayEnabled = (date, weekdaysArr) => weekdaysArr[date.getUTCDay()];

export const dayIsInArray = (day, arr) => arr.some(item => getStartOfDay(item).getTime() === day.getTime());

export const getMinutesBeforeReservation = (reservationTime, timezone) => (
  moment(reservationTime, config.timeSlugFormat).tz(timezone).diff(moment().tz(timezone), 'minutes')
);

export const isLessThanPrepayOnlyThreshold = (minutesBeforeAppointment, shop) => (
  minutesBeforeAppointment < shop.prepayOnlyThreshold
);



// WEBPACK FOOTER //
// ./src/app/utils/schedule.js